import React, { useState, useEffect } from 'react'
// import NotFound from '../../../components/not-found/NotFound'
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded'
// import { toastMessage } from '../../../utils/toastMessage'
import { useSearchParams } from 'react-router-dom'
// import { getConsultantOrderHistoryApi } from '../../../services/consultantManagement'
// import useFullPageLoader from '../../../hooks/useFullPageLoader'
import Pagination from 'react-js-pagination'
import { dateFormatWithTime } from '../../utils/dateFormat'
import NotFound from '../../components/not-found/NotFound'
import IconButton from '../../components/Button/IconButton'
import VisibilityIcon from "@mui/icons-material/Visibility";
import { addRemedy, fetchAOCList, fetchAOCList1 } from '../../services/userManagement';
import ModalBox from "../../components/modal/ModalBox";
import { FaPlay, FaPause } from 'react-icons/fa';
import { setJwtToken } from '../../config/axiosInstance'
import axios from 'axios'
import { Chathistory } from '../../services/consultantManagement'
// import { dateFormatWithTime } from '../../../utils/dateFormat'

const UserConsultantListing = ({ handlePageChange, total, activePage, orderList, show, close, listing, username }) => {

  let URL = process.env.REACT_APP_API_URL
  const [aocList, setAOCList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [remedyList, setRemedyList] = useState([]);
  const [description, setDescription] = useState('');
  const [input, setInput] = useState({ concern: "" });
  const [attachment, setAttachment] = useState(null);
  const [userId, setUserId] = useState(null);
  const [consultantId, setConsultantId] = useState(null);
  const [consultantRequestFormId, setConsultantRequestFormId] = useState(null);
  const [open, setOpen] = useState(false);
  const [openModalIndex, setOpenModalIndex] = useState(null);
  const [chats, setChats] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  console.log('orderlistbegin------>', orderList)
  const [selectedUserName, setSelectedUserName] = useState("");

  const openModal = () => setShowModal(true);

  const BASE_URL = "http://localhost:8080";

  // // ✅ Close Modal
  const closeModal = () => {
    setShowModal(false);
    setInputs({
      title: "",
      concern: "",
      remedy: "",
    });
    setDescription("");
    setConsultantRequestFormId(null);
    setConsultantId(null);
    setUserId(null);
    setAttachment(null);
    setRemedyList([]);
    setAOCList([]);
  };


  const [inputs, setInputs] = useState({
    title: "",
    concern: "",
    remedy: "",
  });

  const handleSubmit = async () => {
    closeModal();
    // Find selected concern and remedy labels
    const selectedConcern = aocList.find((item) => item.id === inputs.concern);
    const selectedRemedy = remedyList.find((item) => item.id === inputs.remedy);

    // Define concernLabel and remedyLabel
    const concernLabel = selectedConcern ? selectedConcern.label : "";
    const remedyLabel = selectedRemedy ? selectedRemedy.label : "";

    const _payload = new FormData();
    _payload.append('type', 'REMEDY');
    _payload.append('consultantRequestFormId', consultantRequestFormId);
    _payload.append('consultantId', consultantId);
    _payload.append('userId', userId);
    _payload.append('title', inputs.title);
    _payload.append('description', description);
    _payload.append('areaOfConcern', concernLabel); // Send concern label instead of ID
    _payload.append('remedy', remedyLabel); // Send remedy label instead of ID
    try {
      const response = await addRemedy(_payload);
      console.log("Remedy added successfully:", response);
    } catch (error) {
      console.error("Error adding remedy:", error);
    }
  };



  const fetchremedy = async () => {
    try {
      const response = await fetchAOCList(); // Fetch from API

      if (!response || !response.data || !response.data.result || !response.data.result.list) {
        console.error("Invalid API response structure", response);
        return;
      }

      // Extract the list from API response
      const list = response.data.result.list.map((element) => ({
        id: element._id,
        label: element.title,
        value: element._id, // Use _id for uniqueness
      }));

      setAOCList(list); // Update state with API data
    } catch (error) {
      console.error("Error fetching remedies:", error);
    }
  };



  useEffect(() => {
    if (inputs.concern) {
      fetchRemedyList();
    }
  }, [inputs.concern]);

  useEffect(() => {
    if (inputs.remedy) {
      fetchDescription();
    }
  }, [inputs.remedy]);


  const fetchRemedyList = async () => {
    try {
      const concernId = inputs.concern; // Get selected concern ID
      if (!concernId) {
        console.error("Concern ID is missing!");
        return;
      }

      const response = await fetchAOCList(concernId); // Call with concernId

      if (!response?.data?.result?.list) {
        console.error("Invalid remedy API response", response);
        return;
      }

      const list = response.data.result.list.map(element => ({
        id: element._id,
        label: element.title,
        value: element.title
      }));

      setRemedyList(list);
    } catch (error) {
      console.error("Error fetching remedy list:", error);
    }
  };

  // fetchRemedyList();


  const fetchDescription = async () => {
    try {

      const concernremedyId = inputs.remedy;
      if (!concernremedyId) {
        console.error("Concern ID is missing!");
        return;
      }
      const response = await fetchAOCList(null, concernremedyId);
      if (!response.data || !response.data.result || !response.data.result.description) {
        console.error("Error: Description field is missing in response");
        return;
      }

      setDescription(response.data.result.description);
    } catch (error) { }
  };

  const handleChange = (e) => {
    setInputs(prevInputs => ({ ...prevInputs, [e.target.name]: e.target.value }));
  };

  // Form Fields
  const fields = [
    { value: "Title*", type: "text", name: "title" },
    { value: null, type: "divider" },
    {
      value: "Area of concern",
      type: "dropdown",
      name: "concern",
      dropdownData: aocList,
    },
    {
      value: "Remedy",
      type: "dropdown",
      name: "remedy",
      dropdownData: remedyList,
    },
    { value: null, type: "divider" },
    {
      value: "Remedy Description",
      type: "text",
      name: "description",
      stateValue: description,
    },
  ];

  const fetchUserChats = async (orderId, orderList) => {
    console.log('Fetching User Chats for Order ID:', orderId);
    setIsLoading(true);

    try {
      // Find the order with the matching orderId
      const order = orderList.find(order => order._id === orderId);

      if (order) {
        const chatId = order?.chats?.[0]?._id;  // Extract first chat ID

        if (!chatId) {
          console.log('Chat ID not found for this user!');
          return;
        }

        // API Call
        const sendData = { chatId: chatId };
        console.log("Sending data to Chathistory:", sendData);

        const { data, status } = await Chathistory(sendData);

        console.log('User chat messages:', JSON.stringify(data));

        if (data && data.result) {
          setChatMessages(data.result.chats);
        } else {
          console.log("No chat data found.");
        }
      } else {
        console.log('Order not found for this user!');
      }
    } catch (error) {
      console.error('Error fetching user chats:', error);
    } finally {
      setIsLoading(false);
      setOpen(true);
    }
  };



  return (
    <>
    <ModalBox
  status={open}
  onClose={() => setOpen(false)}
  title={selectedUserName}
  customizedFooter
  size={"sm"}
  closeIcon
  custom
>
  <div className="chat-container">
    {chatMessages.length > 0 ? (
      chatMessages.map((message, index) => {
        const timestamp = new Date(message.createdAt).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
          day: "numeric",
          month: "numeric",
          year: "2-digit",
        });

        return (
          <div
            key={index}
            style={{ border: '2px solid #000', padding: '10px', borderRadius: '10px', marginTop: '10px' }}
            className={`message-${message.isMessageByUser ? 'consultant' : 'user'}`}
          >
            {message?.messageType === 1 ? (
              <p>{message.message || ''}</p>
            ) : message?.messageType === 5 ? (
              message.file?.[0]?.mediaType === 'image' ? (
                <img src={message.file[0].mediaUrl} alt="Media" className="message-image" />
              ) : message.file?.[0]?.mediaType === 'audio' ? (
                <AudioPlayer source={message.file[0].mediaUrl} />
              ) : null
            ) : null}
            <span className="timestamp" style={{ alignSelf: 'center' }}>{timestamp} </span>
          </div>
        );
      })
    ) : (
      <p>No chat history found.</p>
    )}
  </div>
</ModalBox>

      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Problem</th>
              <th>Consultant</th>
              <th>Date and Time</th>
              <th>Consultant Type</th>
              <th>Chat History</th>
              <th>Send Remedy</th>
              <th>Status</th>
              <th>Amount</th>
            </tr>
          </thead>
          {/* profile: profileImage, name: 'Rahul Chauhan', userId: '123456789',
              PhoneNumber: '1234567890', Email: 'rahul@gmail.com', gender:
              'male', RegistrationDate: '12 Jan 1234', */}
          <tbody>
            {orderList.length > 0 ? (
              orderList.map((order, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td>{++index}</td>
                      <td>{order.areaOfConcern || '---'}</td>
                      <td>{`${order?.consDetails?.name}`}</td>
                      <td>{dateFormatWithTime(order?.createdAt) || '---'}</td>
                      <td>{order?.typeOfConsult || '---'}</td>
                      <td>
                        {order?.typeOfConsult === "chat" &&
                          order?.isConsultantCompleted === "complete" &&
                          order?.typeOfConsult !== "audio" &&
                          order?.typeOfConsult !== "video" ? (
                          <IconButton
                            aria-label="view-user-chat"
                            className="px-2 py-0"
                          >
                            <VisibilityIcon
                              className="eye_icon"
                              onClick={() => {
                                setOpen(true);
                                fetchUserChats(order._id, orderList);
                                setSelectedUserName(`${order?.firstName} ${order?.lastName}`);
                              }}
                            />
                          </IconButton>
                        ) : (
                          "-----"
                        )}
                      </td>

                      <td>
                        <div className="action_button">
                          <IconButton
                            aria-label="update"
                            className="px-2 py-0"
                            onClick={() => {
                              openModal();
                              setUserId(order?.userId);
                              setConsultantId(order?.consDetails?._id);
                              setConsultantRequestFormId(order?._id);
                              fetchremedy();
                            }}
                          // ✅ Corrected here
                          >
                            <VisibilityIcon className="eye_icon" />
                          </IconButton>
                        </div>

                      </td>
                      <td>{order?.isConsultantCompleted || "---"}</td>
                      <td>{order?.totalAmountPayToConsultant || '---'}</td>
                    </tr>
                  </React.Fragment>
                )
              })
            ) : (
              <NotFound
                cols={6}
                msg="No Order Found!"
                icon={<ViewListRoundedIcon sx={{ fontSize: 48 }} />}
              // loader={loader}
              />
            )}
          </tbody>
        </table>
        {total > 1 ? (
          <div className="pagination-wrapper">
            <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div>
        ) : null}
      </div>

      {showModal && <ModalBox
        status={showModal}
        onClose={closeModal}
        title={`Send Remedy to ${username}`}
        size={"sm"}
        closeIcon
        custom
        customizedFooter={
          <div style={{ maxWidth: '650px', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: '440px' }} >
              {fields.map((element, index) => (
                <div key={index}>
                  {element.type === "divider" ? (
                    <hr className="divider" />
                  ) : element.type === "dropdown" ? (
                    <div style={{ gap: '5px' }}>
                      <label style={{ color: 'black' }}>{element.value}</label>
                      <select
                        name={element.name}
                        value={inputs[element.name] || ""}
                        onChange={(e) => handleChange(e)}
                        style={{ borderRadius: '8px', alignSelf: 'center', marginTop: '5px', marginBottom: '5px' }}
                      >
                        <option value="">Select {element.value}</option>
                        {element.dropdownData.map((item) => (
                          <option key={item.id} value={item.id} style={{ borderRadius: '8px', alignSelf: 'center', width: '350px' }}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <div>
                      <label style={{ color: 'black' }}>{element.value}</label>
                      {element.name === "description" ? (
                        // ✅ Use <textarea> for description
                        <textarea
                          name={element.name}
                          value={description}
                          onChange={handleChange}
                          placeholder="Enter"
                          disabled
                          style={{
                            height: '100px',
                            width: '100%',
                            resize: 'none',
                            color: 'black', // Change text color
                            fontSize: '16px', // Change font size
                            fontWeight: 'normal', // Optional: Make text bold
                            borderRadius: '8px', // Optional: Rounded corners
                            padding: '10px',
                            borderColor: 'black' // Optional: Add padding inside
                          }}
                        />
                      ) : (
                        // ✅ Use <input> for all other fields (including Title)
                        <input
                          type="text"
                          name={element.name}
                          value={inputs[element.name] || ""}
                          onChange={handleChange}
                          placeholder="Enter"
                        />
                      )}
                    </div>
                  )}
                </div>
              ))}


            </div>
            <button
              onClick={handleSubmit}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "20px",
                backgroundColor: "#FF6666",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                alignSelf: 'center',
              }}
            >
              Send Remedy
            </button>
          </div>

        }
      />}

    </>
  )
}
export default UserConsultantListing



const AudioPlayer = ({ source }) => {
  const [audio, setAudio] = useState(new Audio(source));
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [audio]);

  const handleAudio = () => {
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="audio-container">
      <button onClick={handleAudio} className="audio-button">
        {isPlaying ? <FaPause /> : <FaPlay />}
      </button>
      <span className="audio-label">Recording</span>
    </div>
  );
};